import React from "react"
import { FaTimes } from "react-icons/fa"

import { Modal } from "components"
import StrrtrmTableRow from "./StrdrmTableRow"
import StrrtrmFooter from "./StrdrmFooter"
import classes from "./index.module.scss"

const StrDeliverRequestModal = (props) => {
  const {
    stockTransferRequest,
    setStockTransferRequests,
    openDeliverConfirmationModal,
    setOpenDeliverConfirmationModal
  } = props

  const acceptedItems =
    stockTransferRequest.requestedItems.filter(requestedItem =>
      requestedItem.acceptedQuantity > 0
    )

  return (
    <Modal
      
      size="lg"
      backdrop="static"
      show={openDeliverConfirmationModal}
      onHide={() => setOpenDeliverConfirmationModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["header"]}>
          <button onClick={() => setOpenDeliverConfirmationModal(false)}>
            <FaTimes />
          </button>
        </div>

        <div className={classes["title"]}>
          جزئیات درخواست
        </div>

        <div className={classes["table-container"]}>
          <table className={classes["table"]}>
            <thead>
              <tr>
                <th style={{ width: "60%" }}>
                  نام کالا
                </th>
                <th style={{ textAlign: "center" }}>
                  مقدار درخواستی
                </th>
                <th style={{ textAlign: "center", width: "20%" }}>
                  مقدار قبول شده
                </th>
              </tr>
            </thead>
            <tbody>
              {acceptedItems.map(acceptedItem =>
                <StrrtrmTableRow
                  key={acceptedItem.optionId}
                  acceptedItem={acceptedItem}
                />
              )}
            </tbody>
          </table >
        </div>

        <StrrtrmFooter
          acceptedItems={acceptedItems}
          stockTransferRequest={stockTransferRequest}
          setStockTransferRequests={setStockTransferRequests}
          setOpenDeliverConfirmationModal={setOpenDeliverConfirmationModal}
        />
      </div>
    </Modal>
  )
}

export default StrDeliverRequestModal